import { useSelector } from './use-selector.js';
import { MultiMeterBarChartState } from '../../types/state.js';

export const useMultiMeterBarSegmentsState = () =>
  useSelector((state: MultiMeterBarChartState) => state.segments);

export const useMultiMeterBarVisibleSegmentsState = () =>
  useSelector((state: MultiMeterBarChartState) =>
    Array.from(state.visibleSegments).map(([, value]) => value),
  );

export const useMultiMeterBarHighlightedSegment = () =>
  useSelector((state: MultiMeterBarChartState) => state.highlightedSegment);
